<template>
  <div>
    <div class="descriptions">
      <div class="title">身份证扫描件</div>
      <expert-upload-view ref="idCardUploadRef" configKey='expert.apply.idcard' :refer-id="id"/>
    </div>
    <div class="descriptions">
      <div class="title">学历证书/毕业证书</div>
      <expert-upload-view ref="diplomaUploadRef" configKey='expert.apply.diploma' :refer-id="id"/>
    </div>
    <div class="descriptions">
      <div class="title">专业技术职称证书</div>
      <div class="img_box">
        <expert-upload-view ref="technicalUploadRef" configKey='expert.apply.technical' :refer-id="id"/>
      </div>
    </div>
    <div class="descriptions" v-show="otherSourceLibraryUploadLength > 0">
      <div class="title">国家、省库专家证明材料</div>
      <div class="img_box">
        <expert-upload-view ref="otherSourceLibraryUploadRef" @change="(length)=>otherSourceLibraryUploadLength=length"
                            configKey='expert.apply.otherSourceLibrary' :refer-id="id"/>
      </div>
    </div>
    <div class="descriptions" v-show="professionalUploadLength > 0">
      <div class="title">职业资格证书等其他资料</div>
      <div class="img_box">
        <expert-upload-view ref="professionalUploadRef" @change="(length)=>professionalUploadLength=length"
                            configKey='expert.apply.professional' :refer-id="id"/>
      </div>
    </div>

  </div>
</template>

<script>

import ExpertUploadView from '@/components/selector/ExpertUploadView.vue'

export default {
  name: 'MaterialView',
  components: { ExpertUploadView },
  props: {
    id: {
      type: String,
      default: undefined
    },
  },
  data () {
    return {
      professionalUploadLength: 0,
      otherSourceLibraryUploadLength: 0
    }
  },

  created () {
  },
  methods: {
    //附件刷新
    fileRefresh () {
      this.$refs.idCardUploadRef.refreshData()
      this.$refs.diplomaUploadRef.refreshData()
      this.$refs.technicalUploadRef.refreshData()
      this.$refs.professionalUploadRef.refreshData()
    }
  }
}
</script>

<style scoped lang="less">
.descriptions{
  .title{
    font-size: 17px;
    font-weight: bold;
    position: relative;
    padding-left: 12px;
    &::before{
      content: "";
      width: 5px;
      height: 14px;
      position: absolute;
      left: 0;
      top: 6px;
      background: #1f76ff;
      border-radius: 10px;
    }
  }
}
</style>
